import React from 'react';
import history from '../../modules/History';
import { Button, notification } from 'antd';
import ReactTable from 'react-table'
import { getReferralSettings } from '../../modules/Api';
import ACL from '../../components/ACL';

class Referral extends React.Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 10,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        getReferralSettings((res) => {
            this.setState({items: res, count: res.length, pageSize: res.length});
        });
    }

    onChange(state) {

    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
                filterable: false,
            },
            {
                Header: 'عنوان',
                accessor: 'title',
                filterable: false,
                Cell: (row) => (<ACL component="span" has_permission="referral_management|referral_edit" denied={() => {return row.original.title;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}}
                                      title={row.original.action} onClick={() => {
                                        window.open(`/referral/edit/${row.original.id}`, "_blank")}
                                      }> {row.original.label} </span></ACL>)
            },
            {
                Header: 'تعداد هدیه',
                accessor: 'amount',
                filterable: false,
            },
            {
                Header: 'عملیات',
                accessor: 'delete',
                sortable: false,
                Cell: (row) => ("")
            }
        ];


        return (
            <div style={{textAlign: 'center'}}>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}


export default Referral;


// WEBPACK FOOTER //
// ./src/containers/Referral/index.js